<template>
  <div class="page_salary page_paymentmanage">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="88px">
            <el-form-item label="到款金额" size="small">
              <el-input v-model="listQuery.IncurredAmount" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="我方户名" size="small">
              <el-select v-model="listQuery.AccountName" placeholder="" clearable filterable style="width:180px">
                <el-option v-for="(item,index) in legList" :key="index" :value="item.name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="对方户名" size="small">
              <el-input v-model="listQuery.OppositeName" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <!-- <el-form-item label="我方户名" size="small">
              <el-input v-model="listQuery.name" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="对方户名" size="small">
              <el-input v-model="listQuery.name" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="到款类型" size="small">
              <el-select v-model="listQuery.name" placeholder="" clearable filterable style="width:180px">
                <el-option value="全部"></el-option>
                <el-option value="开票回款"></el-option>
                <el-option value="预收款"></el-option>
                <el-option value="内部拆借"></el-option>
                <el-option value="融资"></el-option>
                <el-option value="退汇"></el-option>
                <el-option value="理赔"></el-option>
                <el-option value="补贴"></el-option>
                <el-option value="其他"></el-option>
              </el-select>
            </el-form-item> -->
          </el-form>
          <div class="screenInput">
            <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
              <i class="i_txt" @click="dropDownScreen">{{ showDropScreen == 1 ? '收起' : '更多' }}<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen == 1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="90px">
          <div>
            <el-form-item label="我方户名" size="small">
              <el-input v-model="listQuery.AccountNo" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="银行序列号" size="small" label-width="115px">
              <el-input v-model="listQuery.BankSerialNumber" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="银行备注" size="small">
              <el-input v-model="listQuery.Purpose" size="small" clearable style="width:180px"></el-input>
            </el-form-item>

            <el-form-item label="项目" size="small" v-if="activeName=='0'">
              <el-select v-model="listQuery.ProjectIdStr" placeholder="" value-key="Projectid" size="small" style="width: 180px;" filterable>
                <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item.Projectid"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="匹配项目" size="small" v-if="activeName=='1' && listQuery.MatchingType=='1'">
              <el-select v-model="listQuery.ProjectId" placeholder="" value-key="Projectid" size="small" style="width: 180px;" filterable clearable>
                <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item.Projectid"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="开始时间" size="small" v-if="activeName!='0'">
              <el-date-picker v-model="listQuery.BankTransactionDateStart     " type="date" value-format="yyyy-MM-dd" style="width: 180px;" placeholder="选择开始时间"></el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间" size="small" v-if="activeName!='0'">
              <el-date-picker v-model="listQuery.BankTransactionDateEnd     " type="date" value-format="yyyy-MM-dd" style="width: 180px;" placeholder="选择结束时间"></el-date-picker>
            </el-form-item>

            <!-- <el-form-item label="认领项目" size="small">
              <el-input v-model="listQuery.name" size="small" clearable></el-input>
            </el-form-item>
            <el-form-item label="创建方式" size="small">
              <el-select v-model="listQuery.name" placeholder="" clearable filterable>
                <el-option label="全部" value=""></el-option>
                <el-option value="CBS"></el-option>
                <el-option value="导入"></el-option>
                <el-option value="人工创建"></el-option>
              </el-select>
            </el-form-item> -->
          </div>
          <!-- <div>
            <el-form-item label="服务部门" size="small">
              <el-input v-model="listQuery.name" size="small" clearable></el-input>
            </el-form-item>
            <el-form-item label="客服" size="small">
              <el-input v-model="listQuery.name" size="small" clearable></el-input>
            </el-form-item>
          </div> -->
        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" plain @click="resetHandle()">清空</el-button>
        <el-button size="small" type="info" plain @click="showDropScreen = -1">关闭</el-button>
        <el-button v-preventReClick size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>薪酬</el-breadcrumb-item>
          <el-breadcrumb-item>到款管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" type="card" @tab-click="changeTab">
          <el-tab-pane label="全部到款" name="5"></el-tab-pane>
          <el-tab-pane label="未认领到款" name="1"></el-tab-pane>
          <el-tab-pane label="已认领到款" name="0"></el-tab-pane>
          <el-tab-pane label="退款记录表" name="3"></el-tab-pane>
        </el-tabs>
        <div class="ftabBtn flex">
          <el-button type="success" size="small" @click="expPayment" :loading="showExportProSum">导出到款</el-button>
          <!-- <el-button type="warning" size="small">导出明细</el-button> -->
          <el-button type="primary" size="small" @click="addPayment" v-if="activeName=='5'">新增到款+</el-button>
          <el-button type="primary" size="small" @click="importPayment" v-if="activeName=='5'">导入到款+</el-button>
          <el-button type="primary" size="small" @click="importBankStatement">导入银行流水信息</el-button>
          <el-button type="success" size="small" @click="batchClaim">批量认领到款</el-button>
          <!-- <el-button type="primary" size="small">批量打印回单</el-button> -->
        </div>
        <el-tabs v-model="listQuery.MatchingType" v-if="activeName=='1'" @tab-click="changeTab2">
          <el-tab-pane label="有匹配项目" name="1"></el-tab-pane>
          <el-tab-pane label="无匹配项目" name="2"></el-tab-pane>
          <el-tab-pane label="内部往来" name="3"></el-tab-pane>
        </el-tabs>
        <el-table :data="tableData" v-if="activeName=='5' || activeName=='1'" class="doc_table" v-loading="loading" :row-key='getRowKeys' ref="paymentTable" @expand-change="handleExpandChange" @selection-change="handleSelectionChange" :row-style="isRed" @row-click="selected" :max-height="tableHeight-150">
          <el-table-column key="mul" type="selection" width="55" align="center" fixed="left"></el-table-column>
          <el-table-column key="need" type="expand" v-if="activeName=='5' || (activeName=='1' && listQuery.MatchingType=='1')" fixed="left">
            <template slot-scope="props">
              <div class="expandTable">
                <el-button type="success" size="small" v-if="expandTotal > 0" @click="exportExpand">导出</el-button>
                <el-table :data="expands" class="doc_table" v-loading="loading">
                  <el-table-column prop="BankSerialNumber" label="到款编号" width="150" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="ClaimNum" label="认领编号" width="100" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="ProjectName" label="认领项目或部门" width="140" :show-overflow-tooltip="true" align="center">
                    <template slot-scope="{row}">{{row.ProjectName ? row.ProjectName : row.Department ? row.Department : ''}}</template>
                  </el-table-column>
                  <el-table-column prop="VestingMonth" label="归属月" width="100" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="AccountName" label="我方户名" width="180" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="OppositeName" label="对方户名" width="130" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="AmountClaime" label="认领金额" width="100" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="PaymentType" label="到款类型" width="100" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="Claimant" label="认领人" width="100" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="CreateTime" label="认领时间" width="155" :show-overflow-tooltip="true" align="center">
                    <template slot-scope={row}>
                      {{ row.CreateTime ? row.CreateTime.replace('T',' ') : '' }}
                    </template>
                  </el-table-column>
                </el-table>
                <div class="block" style="max-width:1000px">
                  <el-pagination v-if="expandTotal>0" @current-change="currentChangeExpand" :current-page.sync="expandQuery.pageNum" :page-size="Number(expandQuery.pageSize)" @size-change="handleSizeChangeExpand" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="expandTotal"></el-pagination>
                </div>

                <!-- <el-table :data="expands" class="doc_table" v-loading="loading" v-if="activeName=='1'" style="max-width: calc(100vw - 500px);">
                  <el-table-column prop="name" label="项目名称" width="100" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="name" label="客户名称" width="100" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="name" label="商务合同主体" width="140" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="name" label="应收账款" width="100" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="name" label="最近开票金额" width="120" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="name" label="最近开票归属月" width="150" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="name" label="最近开票时间" width="120" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="name" label="最近发薪金额" width="120" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="name" label="最近发薪垫支金额" width="150" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="name" label="最近发薪薪资归属月" width="150" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column prop="name" label="最近发薪时间" width="120" :show-overflow-tooltip="true" align="center">
                  </el-table-column>
                  <el-table-column label="操作" align="center" width="100px" fixed="right">
                    <template slot-scope={row}>
                      <div class="injuryTabBtn">
                        <el-button type="text">认领到款</el-button>
                      </div>
                    </template>
                  </el-table-column>
                </el-table> -->
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="OppositeName" label="对方户名" width="240" :show-overflow-tooltip="true" align="center" fixed="left">
          </el-table-column>
          <el-table-column prop="OppositeOpeningBank" label="对方开户行" width="200" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="OppositeAccount" label="对方账号" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="IncurredAmount" label="交易金额" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Currency" label="币种" width="80" :show-overflow-tooltip="true" align="center" v-if="activeName=='5'">
            <template slot-scope="{row}">{{getCurrency(row.Currency)}}</template>
          </el-table-column>
          <el-table-column prop="RefundAmount" label="退款金额" width="100" :show-overflow-tooltip="true" align="center" v-if="activeName=='5'">
          </el-table-column>
          <el-table-column prop="FundsReceived" label="实收金额" width="100" :show-overflow-tooltip="true" align="center" v-if="activeName=='5'">
          </el-table-column>
          <el-table-column prop="AmountClaimed" label="已认领金额" width="100" :show-overflow-tooltip="true" align="center" v-if="activeName=='5'">
          </el-table-column>
          <el-table-column prop="NotAmountClaimed" label="待认领金额" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="ClaimStatus" label="认领状态" width="100" :show-overflow-tooltip="true" align="center" v-if="activeName=='5'">
            <template slot-scope={row}>
              {{ row.ClaimStatus=='1' ? '未认领' : '已认领完' }}
            </template>
          </el-table-column>
          <el-table-column prop="BankTransactionDate" :label="activeName=='5' ? '交易时间' : '到款时间'" width="155" :show-overflow-tooltip="true" align="center" v-if="activeName=='5' || activeName=='1'">
            <template slot-scope={row}>
              {{ row.BankTransactionDate ? row.BankTransactionDate.replace('T',' ') : '' }}
            </template>
          </el-table-column>
          <el-table-column prop="AccountName" label="我方户名" width="180" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="OpenBank" label="我方开户行" width="130" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="AccountNo" label="我方银行账号" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="CreateMode" label="创建方式" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <!-- <el-table-column prop="AttachmentUrl" label="客户原表附件" width="120" :show-overflow-tooltip="true" align="center" v-if="activeName=='5'">
          </el-table-column> -->
          <el-table-column prop="PaymentNum" label="到款编号" width="200" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="TransactionSerialNumber" label="银行到款流水号" width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Digest" label="备注" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Purpose" label="银行备注" width="200" :show-overflow-tooltip="true" align="center">
          </el-table-column>

          <el-table-column label="操作" align="center" fixed="right" width="200px">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <!-- <el-dropdown trigger="click">
                  <span class="el-dropdown-link">
                    <img src="../../assets/employee/images/more.png" style="width: 14px; height: 16px; cursor: pointer" />
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>打印回单</el-dropdown-item>
                    <el-dropdown-item v-if="activeName=='1'" @click.native="showRefund = true">登记退款</el-dropdown-item>
                    <el-dropdown-item v-if="activeName=='1'" @click.native="showNoTicket = true">登记无票收入</el-dropdown-item>
                    <el-dropdown-item v-if="activeName=='1'" @click.native="claim(row)">认领到款</el-dropdown-item>
                    <el-dropdown-item v-if="activeName=='1' && listQuery.MatchingType=='2'" @click.native="showOther = true">登记其他</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown> -->
                <el-button type="text" v-if="row.CreateMode=='CBS'" @click="downReceiptSingle(row)">下载回单</el-button>
                <el-button type="text" v-if="activeName=='1'" @click="refund(row)">登记退款</el-button>
                <el-button type="text" v-if="activeName=='1'" @click.native="showNoTicket = true">登记无票收入</el-button>
                <el-button type="text" v-if="row.ClaimStatus == '1'" @click.native="claimHandle(row,'showClaim')">认领到款</el-button>
                <el-button type="text" v-if="row.ClaimStatus == '1'" @click.native="claimHandle(row,'showClaimFinance')">财务认领</el-button>
                <el-button type="text" v-if="activeName=='1' && listQuery.MatchingType=='2'" @click.native="showOther = true">登记其他</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>


        <el-table :data="tableData2" class="doc_table" v-loading="loading" style="width:100%" v-if="activeName=='0' || activeName=='3'" row-key="Id" :max-height="tableHeight-150">
          <el-table-column prop="Sort" label="序号" width="50" align="center" fixed="left">
            <template slot-scope="scope">
              {{(listQuery.pageNum - 1) * Number(listQuery.pageSize)  + scope.$index + 1}}
            </template>
          </el-table-column>
          <template v-if="activeName=='0'">
            <el-table-column prop="ClaimNum" label="认领编号" width="100" key="1" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="BankSerialNumber" label="到款编号" width="100" key="2" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="TransactionSerialNumber" label="银行流水号" width="100" key="3" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="Department" label="认领项目/部门" width="140" key="4" :show-overflow-tooltip="true" align="center">
              <template slot-scope="{row}">{{row.ProjectName ? row.ProjectName : row.Department ? row.Department : ''}}</template>
            </el-table-column>
            <el-table-column prop="VestingMonth" label="归属月" width="100" key="5" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="AmountClaime" label="认领金额" width="120" key="6" :show-overflow-tooltip="true" align="center">   
            </el-table-column>
            <el-table-column prop="CreateTime" label="认领时间" width="130" key="7" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="BankTransactionDate" label="到款时间" width="130" key="8" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="PaymentType" label="到款类型" width="100" key="9" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="Claimant" label="认领人" width="100" key="10" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="OppositeName" label="对方户名" width="180" key="11" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="AccountName" label="我方户名" width="180" key="12" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="IncurredAmount" label="到款金额" width="100" key="13" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="EmainingAvailableCredit" label="剩余可用金额" width="100" key="14" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="Remark" label="备注" width="100" key="15" :show-overflow-tooltip="true" align="center">
            </el-table-column>
          </template>
          <template v-if="activeName=='3'">
            <el-table-column prop="PaymentNum" label="到款编号" width="100" key="1" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="RefundNum" label="退款编号" width="100" key="2" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="TransactionSerialNumber" label="银行流水号" width="100" key="3" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="OppositeName" label="对方开户名" width="140" key="4" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="OppositeOpeningBank" label="对方开户行" width="100" key="5" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="OppositeAccount" label="对方账号" width="100" key="6" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="RefundAmount" label="退款金额" width="100" key="7" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="RefundTime" label="退款时间" width="130" key="8" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="RefundStatus" label="退款状态" width="100" key="9" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="CreateMode" label="退款方式" width="100" key="10" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <!-- <el-table-column prop="name" label="归属月" width="180" :show-overflow-tooltip="true" align="center">
            </el-table-column> -->
            <el-table-column prop="AccountName" label="我方户名" width="180" key="11" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="OpenBank" label="我方开户行" width="100" key="12" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="AccountNo" label="我方银行账号" width="120" key="13" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="Remark" label="备注" width="100" key="14" :show-overflow-tooltip="true" align="center">
            </el-table-column>
          </template>
          <el-table-column label="操作" align="center" fixed="right" width="140px" v-if="activeName=='0'">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-button type="text" @click="revokeClaim(row)">撤销认领</el-button>
                <el-button type="text" @click="revokePayDuc(row)">撤销抵扣</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="新增到款" :visible.sync="showAddPayment" width="900px">
      <el-form :model="formData" :inline="true" ref="formData" :rules="rules" label-width="100px">
        <div>
          <el-form-item label="归属">
            <el-radio-group v-model="claimBelong" @change="changeBelong">
              <el-radio label="1">项目</el-radio>
              <el-radio label="2">部门</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <el-form-item label="项目" v-if="claimBelong=='1'" prop="ProjectID">
          <el-select v-model="ProjectName" placeholder="" value-key="Projectid" size="small" style="width: 300px;" filterable @change="changePro">
            <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部门" v-if="claimBelong=='2'" prop="department">
          <el-cascader v-model="department" ref="depart" :props="props" filterable :show-all-levels="false" placeholder="请选择部门" :options="departList" @change="handleSectionChange" size="small" style="width:300px"></el-cascader>
        </el-form-item>
        <!-- <el-form-item label="客户名称" prop="name">
          <el-input v-model="formData.name" style="width:300px" size="small"></el-input>
        </el-form-item> -->
        <el-form-item label="认领金额" prop="AmountClaime">
          <el-input type="number" v-model="formData.AmountClaime" style="width:300px" size="small" @input="changeAmountClaime"></el-input>
        </el-form-item>
        <el-form-item label="归属月" prop="VestingMonth">
          <el-date-picker type="month" v-model="formData.VestingMonth" value-format="yyyy-MM" style="width:300px;" size="small"></el-date-picker>
        </el-form-item>

        <el-form-item label="我方户名" prop="accountName">
          <el-select v-model="formData.accountName" placeholder="" clearable filterable size="small" style="width:300px">
            <el-option v-for="(item,index) in legList" :key="index" :value="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="我方开户行" prop="openBank">
          <el-input v-model="formData.openBank" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="到款类型" prop="PaymentType">
          <el-select v-model="formData.PaymentType" placeholder="" clearable filterable style="width:300px" size="small">
            <el-option value="回款"></el-option>
            <el-option value="待认领"></el-option>
            <el-option value="预收款"></el-option>
            <el-option value="退汇"></el-option>
            <el-option value="内部拆借"></el-option>
            <el-option value="融资"></el-option>
            <el-option value="理赔款"></el-option>
            <el-option value="补贴"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="到款日期" prop="bankTransactionDate">
          <el-date-picker type="date" placeholder="" v-model="formData.bankTransactionDate" value-format="yyyy-MM-dd" style="width:300px" size="small"></el-date-picker>
        </el-form-item>
        <el-form-item label="到款金额" prop="incurredAmount">
          <el-input type="number" v-model="formData.incurredAmount" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="对方开户名" prop="oppositeName">
          <el-input v-model="formData.oppositeName" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="对方账号" prop="oppositeAccount">
          <el-input v-model="formData.oppositeAccount" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="对方开户行" prop="oppositeOpeningBank">
          <el-input v-model="formData.oppositeOpeningBank" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="Remark">
          <el-input v-model="formData.Remark" style="width:300px" size="small"></el-input>
        </el-form-item>
        <div>
          <el-form-item label="到款通知截图" prop="AttachmentUrl">
            <el-upload action="" list-type="picture-card" accept=".png,.jpg,.gif" :on-preview="handlePictureCardPreview" :on-remove="handleRemovePic" :on-change="handleChangePic" :on-exceed="handleExceedPic" :auto-upload="false" :multiple="false" :limit="9" :file-list="PicList">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisiblePic" append-to-body>
              <img width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAddPayment = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmAddPayment">提 交</el-button>
      </span>
    </el-dialog>

    <el-dialog title="导入到款" :visible.sync="showImportPayment" width="900px">
      <el-form :inline="true" label-width="100px">
        <el-form-item label="导入" prop="name">
          <div style="width:300px">
            <div class="file-box">
              <input readonly style="width: 200px;height:32px;margin-top: 4px;" id="applyLicense" type="text" v-model="ExcelSrc.fileName" autocomplete="off">
              <input id="fileInput" type="file" name="file" accept=".xlsx,.xls" @change="importf(this)" ref="upload">
              <label for="fileInput" class="file-btn cp">上传</label>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="导入模板下载" prop="name">
          <div style="width:300px">
            <el-button type="text" @click="downTemp">下载</el-button>
          </div>
        </el-form-item>
      </el-form>
      <div v-if="isUploadSuccess && importTable.length>0">
        <div class="impDtl">导入结果明细：</div>
        <el-table :data="importTable" class="doc_table" v-loading="!isUploadSuccess">
          <el-table-column prop="TransactionSerialNumber" label="用户到款流水号" width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <!-- <el-table-column prop="name" label="项目或部门" width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="name" label="归属月" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column> -->
          <el-table-column prop="OppositeName" label="对方户名" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="OppositeOpeningBank" label="对方开户行" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="OppositeAccount" label="对方账号" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="name" label="交易金额" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Currency" label="币种" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <!-- <el-table-column prop="name" label="实收金额" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column> -->
          <el-table-column prop="BankTransactionDate1" label="交易时间" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="AccountName" label="我方户名" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="OpenBank" label="我方开户行" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="AccountNo" label="我方银行账号" width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="CreateMode" label="创建方式" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <!-- <el-table-column prop="name" label="备注" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column> -->
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showImportPayment = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmImport()">提 交</el-button>
      </span>
    </el-dialog>

    <el-dialog title="认领到款" :visible.sync="showClaim" width="900px">
      <el-form :inline="true" :model="claimForm" label-width="100px">
        <div>
          <el-form-item label="归属" prop="name">
            <el-radio-group v-model="claimBelong" @change="changeBelong">
              <el-radio label="1">项目</el-radio>
              <el-radio label="2">部门</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <el-form-item label="项目" prop="ProjectName" v-if="claimBelong=='1'">
          <el-select v-model="ProjectName" placeholder="" value-key="Projectid" size="small" style="width: 300px;" filterable @change="changePro">
            <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部门" prop="department" v-if="claimBelong=='2'">
          <el-cascader v-model="claimDepartment" ref="depart1" :props="props" filterable :show-all-levels="false" placeholder="请选择部门" :options="departList" @change="handleSectionChange1" size="small" style="width:300px"></el-cascader>
        </el-form-item>
      </el-form>
      <div class="basicInfo flex aic" v-if="showClaim">
        <div class="infoItem" v-if="ContractParty">商务合同主体: {{ ContractParty }}</div>
        <div class="infoItem">对方户名: {{info.OppositeName}}</div>
        <div class="infoItem">我方户名: {{info.AccountName}}</div>
        <div class="infoItem">到款日期: {{ info.BankTransactionDate ? info.BankTransactionDate.split('T')[0] : ''}}</div>
        <div class="infoItem">银行流水号: {{info.TransactionSerialNumber}}</div>
        <div class="infoItem">到款编号: {{info.BankSerialNumber}}</div>
        <div class="infoItem">到款金额: {{info.IncurredAmount}}</div>
        <div class="infoItem">待认领金额: {{info.NotAmountClaimed}}</div>
      </div>
      <div class="claimTitle" style="margin-bottom: 15px;">认领项目开票回款</div>
      <el-form :model="claimForm" ref="claimForm" :inline="true" label-width="100px">
        <div v-for="(item,index) in claimForm.list" :key="index">
          <el-form-item label=" 归属月" :prop="`list[${index}].VestingMonth`" :rules="{
            required: true, message: '请选择归属月', trigger: 'change'
              }">
            <el-date-picker type="month" placeholder="归属月" v-model="item.VestingMonth" value-format="yyyy-MM" style="width:150px;margin-left: 15px;" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label=" 本次认领到款">
            <el-input v-model="item.AmountClaime" type="number" style="width:150px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="备注" label-width="60px">
            <el-input v-model="item.Remark" style="width:150px" size="small"></el-input>
          </el-form-item>
          <el-button type="text" v-if="index!=0" @click="delLine(index)">删除</el-button>
        </div>
      </el-form>
      <el-button type="text" @click="addLine">增加行+</el-button>

      <!-- <div class="claimTitle" style="margin-bottom: 15px;">仅登记为部门到款>>
      </div>
      <el-cascader v-model="Strorganname" ref="depart" :props="props" filterable :show-all-levels="false" placeholder="请选择部门" :options="departList" @change="handleSectionChange" size="small" style="width:300px"></el-cascader> -->

      <span slot="footer" class="dialog-footer">
        <el-button @click="showClaim = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmClaim">提 交</el-button>
      </span>
    </el-dialog>

    <el-dialog title="财务认领" :visible.sync="showClaimFinance" width="900px">
      <el-form :inline="true" :model="claimForm" label-width="100px">
        <div>
          <el-form-item label="归属" prop="name">
            <el-radio-group v-model="claimBelong" @change="changeBelong">
              <el-radio label="1">项目</el-radio>
              <el-radio label="2">部门</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <el-form-item label="项目" prop="ProjectName" v-if="claimBelong=='1'">
          <el-select v-model="ProjectName" placeholder="" value-key="Projectid" size="small" style="width: 300px;" filterable @change="changePro">
            <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部门" prop="department" v-if="claimBelong=='2'">
          <el-cascader v-model="claimDepartment" ref="depart1" :props="props" filterable :show-all-levels="false" placeholder="请选择部门" :options="departList" @change="handleSectionChange1" size="small" style="width:300px"></el-cascader>
        </el-form-item>
      </el-form>
      <div class="basicInfo flex aic" v-if="showClaimFinance">
        <div class="infoItem" v-if="ContractParty">商务合同主体: {{ ContractParty }}</div>
        <div class="infoItem">对方户名: {{info.OppositeName}}</div>
        <div class="infoItem">我方户名: {{info.AccountName}}</div>
        <div class="infoItem">到款日期: {{ info.BankTransactionDate ? info.BankTransactionDate.split('T')[0] : ''}}</div>
        <div class="infoItem">银行流水号: {{info.TransactionSerialNumber}}</div>
        <div class="infoItem">到款编号: {{info.BankSerialNumber}}</div>
        <div class="infoItem">到款金额: {{info.IncurredAmount}}</div>
        <div class="infoItem">待认领金额: {{info.NotAmountClaimed}}</div>
      </div>
      <div class="claimTitle" style="margin-bottom: 15px;">认领项目开票回款</div>
      <el-form :model="claimForm" ref="claimForm" :inline="true" label-width="100px">
        <div v-for="(item,index) in claimForm.list" :key="index">
          <el-form-item label=" 归属月">
            <el-date-picker type="month" placeholder="归属月" v-model="item.VestingMonth" value-format="yyyy-MM" style="width:150px;margin-left: 15px;" size="small"></el-date-picker>
          </el-form-item>
          <el-form-item label=" 本次认领到款">
            <el-input v-model="item.AmountClaime" type="number" style="width:150px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="备注" label-width="60px">
            <el-input v-model="item.Remark" style="width:150px" size="small"></el-input>
          </el-form-item>
          <el-button type="text" v-if="index!=0" @click="delLine(index)">删除</el-button>
        </div>
      </el-form>
      <el-button type="text" @click="addLine">增加行+</el-button>

      <!-- <div class="claimTitle" style="margin-bottom: 15px;">仅登记为部门到款>>
      </div>
      <el-cascader v-model="Strorganname" ref="depart" :props="props" filterable :show-all-levels="false" placeholder="请选择部门" :options="departList" @change="handleSectionChange" size="small" style="width:300px"></el-cascader> -->

      <span slot="footer" class="dialog-footer">
        <el-button @click="showClaimFinance = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmClaim">提 交</el-button>
      </span>
    </el-dialog>

    <el-dialog title="批量认领到款" :visible.sync="showBatchClaim" width="600px">
      <el-form :inline="true" :model="claimForm" label-width="100px">
        <div>
          <el-form-item label="归属" prop="name">
            <el-radio-group v-model="claimBelong" @change="changeBelong">
              <el-radio label="1">项目</el-radio>
              <el-radio label="2">部门</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <el-form-item label="项目" prop="ProjectName" v-if="claimBelong=='1'">
          <el-select v-model="ProjectName" placeholder="" value-key="Projectid" size="small" style="width: 300px;" filterable @change="changePro">
            <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部门" prop="department" v-if="claimBelong=='2'">
          <el-cascader v-model="claimDepartment" ref="depart1" :props="props" filterable :show-all-levels="false" placeholder="请选择部门" :options="departList" @change="handleSectionChange1" size="small" style="width:300px"></el-cascader>
        </el-form-item>
      </el-form>
      <div class="claimTitle" style="margin-bottom: 15px;">认领项目开票回款</div>
      <el-form :inline="true" label-width="100px">
        <div v-for="(item,index) in claimForm.list" :key="index">
          <el-form-item label="预收款金额" prop="name">
            <el-input v-model="item.AmountClaime" style="width:150px" size="small"></el-input>
            <el-date-picker type="month" placeholder="归属月" v-model="item.VestingMonth" value-format="yyyy-MM" style="width:150px;margin-left: 15px;" size="small"></el-date-picker>
          </el-form-item>
          <el-button type="text" v-if="index!=0" @click="delLine(index)">删除</el-button>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showBatchClaim = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmBatchClaim">确 认</el-button>
      </span>
    </el-dialog>

    <el-dialog title="撤销认领" :visible.sync="showRevokeClaim" width="500px">
      <el-form label-width="100px" v-if="showRevokeClaim">
        <el-form-item label="认领编号">
          <div class="form_item">{{info.ClaimNum}}</div>
        </el-form-item>
        <el-form-item label="到款类型">
          <div class="form_item">{{info.PaymentType}}</div>
        </el-form-item>
        <el-form-item label="认领金额">
          <div class="form_item">{{info.AmountClaime}}</div>
        </el-form-item>
        <el-form-item label="剩余可用额度">
          <div class="form_item">{{info.EmainingAvailableCredit}}</div>
        </el-form-item>
        <el-form-item label="撤销认领金额" prop="AmountClaime">
          <el-input type="number" v-model="revokeForm.AmountClaime" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="revokeForm.remark" style="width:300px" size="small"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showRevokeClaim = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmRevokeClaim">确 认</el-button>
      </span>
    </el-dialog>

    <el-dialog title="登记退款" :visible.sync="showRefund" width="500px">
      <el-form label-width="110px" :model="refundForm" v-if="showRefund" ref="refundForm" :rules="refundRules">
        <el-form-item label="到款编号">
          <div class="form_item">{{info.PaymentNum}}</div>
        </el-form-item>
        <el-form-item label="银行到款流水号">
          <div class="form_item">{{info.TransactionSerialNumber}}</div>
        </el-form-item>
        <el-form-item label="对方开户行">
          <div class="form_item">{{info.OppositeOpeningBank}}</div>
        </el-form-item>
        <el-form-item label="对方户名">
          <div class="form_item">{{info.OppositeName}}</div>
        </el-form-item>
        <el-form-item label="对方账号">
          <div class="form_item">{{info.OppositeAccount}}</div>
        </el-form-item>
        <el-form-item label="我方户名">
          <div class="form_item">{{info.AccountName}}</div>
        </el-form-item>
        <el-form-item label="我方账号">
          <div class="form_item">{{info.AccountNo}}</div>
        </el-form-item>
        <el-form-item label="退款金额" prop="RefundAmount">
          <el-input v-model="refundForm.RefundAmount" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="联行号" prop="cnapsCode">
          <el-input v-model="refundForm.cnapsCode" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="refundForm.remark" style="width:300px" size="small"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showRefund = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmRefund('手动')" :loading="isBtnLoading">仅登记退款</el-button>
        <el-button type="warning" v-preventReClick style="margin-left:10px;" size="small" @click="confirmRefund('CBS')" :loading="isBtnLoading">CBS操作退款</el-button>
      </span>
    </el-dialog>

    <el-dialog title="抵扣记录" :visible.sync="showClaimHistory" width="500px">
      <el-table :data="claimHistoryList" style="width:100%">
        <el-table-column prop="AdvanceNum" label="发薪编号" min-width="160" :show-overflow-tooltip="true" align="center" fixed="left">
        </el-table-column>
        <el-table-column prop="currentWrittenAmount" label="抵扣金额" min-width="120" :show-overflow-tooltip="true" align="center">
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showClaimHistory = false" size="small">关 闭</el-button>
      </span>
    </el-dialog>


    <el-dialog title="导入银行流水信息" :visible.sync="showBankStatement" width="500px">
      <el-form :model="bankForm" ref="bankForm" :rules="bankRules" label-width="100px">
        <el-form-item label="导入表" prop="templateType">
          <el-radio-group v-model="bankForm.templateType">
            <el-radio :label="1">标准格式</el-radio>
            <el-radio :label="2">银行原表</el-radio>
            <el-radio :label="3">合作账户</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="账户卡号" prop="accountNo">
          <el-input v-model="bankForm.accountNo" @blur="getBankInfo(bankForm.accountNo)" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="开户行" prop="openingBank">
          <el-input v-model="bankForm.openingBank" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="账户名称" prop="accountName">
          <el-input v-model="bankForm.accountName" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="上传文件" prop="fileUrl">
          <el-upload class="upload-demo" action="" :on-remove="handleRemove" multiple :limit="1" :auto-upload="false" :on-exceed="handleExceed" :on-change="handleUpload" accept=".xlsx,.xls" :file-list="fileList">
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <!-- <el-form-item label="导入模板下载" prop="name">
          <div style="width:300px">
            <el-button type="text" @click="downBSTemp">下载模板</el-button>
          </div>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showBankStatement = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmImportBankStatement()" :loading="isBtnLoading">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import FUN from "../../fun";
  import moment from 'moment';
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        listQuery: {
          IncurredAmount: '', //认领金额
          AccountName: '', //我方户名
          OppositeName: '', //对方户名
          pageNum: 1,
          pageSize: 10,
          AccountNo: '', //我方户名
          MatchingType: '2', //有匹配为1,无匹配为2，内部往来为3 
          ClaimStatus: '1', //为1未认领，0为已认领完
          Purpose: '', //银行备注 
          BankSerialNumber: '',
        },
        showDropScreen: -1,
        tableData: [],
        expands: [],
        formData: {
          name: '',
          accountNo: '', //账户号
          accountName: '', //账户名
          bankType: '', //银行类型
          openBank: '', //	开户银行
          incurredAmount: '', //发生金额
          accountBalance: '', //账户余额
          oppositeAccount: '', //对方账户
          oppositeName: '', //对方名称
          oppositeOpeningBank: '', //对方开户银行
          AttachmentUrl: '', //附件url         
          ProjectID: '',
          ProjectName: '',
          department: '',
          AmountClaime: '', //认领金额
          VestingMonth: '', //归属月
          Remark: '',
          PaymentType: '回款', //到款类型
          TransactionSerialNumber: '', //银行到款流水号
          bankTransactionDate: '', //银行交易日期
        },
        roletype: localStorage.loginRoletype,
        totalCount: 0,
        Num: 6,
        activeName: '1',
        loading: false,
        showImportPayment: false, //导入到款
        showAddPayment: false, //新增到款弹窗
        showClaim: false, //认领到款弹窗
        showClaimFinance: false, //财务认领弹窗
        showRefund: false, //登记退款弹窗
        showNoTicket: false, //登记无票收入弹窗
        showOther: false, //登记其他弹窗
        showRevokeClaim: false, //撤销认领弹窗
        rules: {
          ProjectID: {
            required: true,
            message: '请选择项目',
            trigger: 'change'
          },
          department: {
            required: true,
            message: '请选择部门',
            trigger: 'change'
          },
          AmountClaime: {
            required: true,
            message: '请输入认领金额',
            trigger: 'blur'
          },
          VestingMonth: {
            required: true,
            message: '请选择归属月',
            trigger: 'change'
          },
          accountName: {
            required: true,
            message: '请选择我方户名',
            trigger: 'change'
          },
          openBank: {
            required: true,
            message: '请输入我方开户行',
            trigger: 'change'
          },
          PaymentType: {
            required: true,
            message: '请选择到款类型',
            trigger: 'change'
          },
          bankTransactionDate: {
            required: true,
            message: '请选择到款日期',
            trigger: 'change'
          },
          incurredAmount: {
            required: true,
            message: '请输入到款金额',
            trigger: 'change'
          },
          oppositeName: {
            required: true,
            message: '请输入对方开户名',
            trigger: 'change'
          },
        },
        refundRules: {
          RefundAmount: {
            required: true,
            message: '请输入退款金额',
            trigger: 'blur'
          }
        },
        departList: [], //部门列表
        Strorganname: '',
        claimForm: {
          Claim: {
            Id: '',
            AccountingRecordId: '', //认领ID
            ProjectID: '', //项目id
            department: '', //部门
            ProjectName: '', //项目名
            PaymentType: '', //到款类型
            ClaimNum: '', //认领编号
            Claimant: '', //认领人
          },
          list: [{
            AmountClaime: '', //认领金额
            VestingMonth: '', //归属月
            Remark: '',
          }],
        },
        claimBelong: '1', //认领归属
        ProjectName: '', //项目名称
        proNameList: [], //项目列表
        customList: [], //客户列表
        props: {
          label: 'strorganname',
          value: 'strorgancode',
          children: 'children',
          checkStrictly: true
        },
        ContractParty: '', //商务合同主体
        info: {},
        revokeForm: {
          id: '',
          AmountClaime: '', //撤销认领金额
          remark: '', //备注
        },
        dialogVisiblePic: false,
        dialogImageUrl: '',
        paymentPic: [],
        department: '',
        claimDepartment: '',
        PicList: [],
        headPath: this.$store.state.EMP.tablePath,
        importForm: {
          url: '',
          ImportTempId: '',
          View: '1', // 1 预览  //2直接导入
        },
        importTable: [], //导入结果预览
        ExcelSrc: {
          value: "",
          check: false,
          fileName: "",
        },
        isUploadSuccess: false, //是否上传成功
        multipleSelection: [],
        expandQuery: {
          pageNum: 1,
          pageSize: 10,
          IsExport: '0', // 1导出 0 查询
          AccountingRecordId: ''
        },
        expandTotal: 0,
        tableData2: [],
        legList: [],
        showExportProSum: false,
        refundForm: {
          Id: '',
          Remark: '',
          PaymentTransfer: '',
          RefundAmount: '',
        },
        fileList: [],
        isBtnLoading: false,
        tableHeight: 0,
        claimHistoryList: [],
        showClaimHistory: false,
        selectedArrData: [],
        showBankStatement: false,
        bankForm: {
          fileUrl: '',
          templateType: 2, //模版类型1.标准格式 2银行原表 3 合作账户
          openingBank: '',
          accountName: '',
          accountNo: '',
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
        },
        showBatchClaim: false,
        bankRules: {
          templateType: {
            required: true,
            message: '请选择导入表',
            trigger: 'change'
          },
          openingBank: {
            required: true,
            message: '请输入开户行',
            trigger: 'blur'
          },
          accountName: {
            required: true,
            message: '请输入账户名称',
            trigger: 'blur'
          },
          accountNo: {
            required: true,
            message: '请输入账户卡号',
            trigger: 'blur'
          },
          fileUrl: {
            required: true,
            message: '请上传文件',
            trigger: 'change'
          }
        }
      }
    },
    created() {
      this.tableHeight = Number(document.body.clientHeight);
      // 获取部门列表
      this.getDepartList();
      this.getProList();
      this.getCusList();
      this.getAccountingRecordsList();
      this.getlegalsubjectlist(); //取主体
    },
    methods: {
      checkPermission,
      //获取项目
      getProList() {
        let data = {
          projectname: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: this.roletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.proNameList = res.msg;
          } else {
            this.proNameList = [];
          }
        });
      },
      // 客户列表
      getCusList() {
        let data = {
          currpage: 1,
          perpage: 100000,
          strorgancode: '',
          roletype: '',
          strCustlevel: '', // 客户等级
          strProvince: '', // 省
          strCity: '', // 市
          custname: '', //客户名称
          username: '', //业务员
          depname: '', //业务部门
          strBusidepList: [], //选中的业务部门
          groupname: '', //所属集团
          strCustType: '', //客户类别
          strCustindust: '' //客户行业
        }
        xz.getCustLists(data).then(res => {
          // console.log('客户', res)
          if (res.status == 'ok') {
            this.customList = res.msg
          } else {
            this.customList = []
          }
        })
      },
      currentChange(val) {
        this.listQuery.pageNum = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageNum = 1;
        this.listQuery.pageSize = val;
        this.getList();
      },
      searchHandle() {
        this.listQuery.pageNum = 1;
        this.getList();
      },
      getList() {
        if (this.activeName == '5' || this.activeName == '1') {
          this.getAccountingRecordsList();
        } else if (this.activeName == '0') {
          this.getClaimList();
        } else {
          this.getRefundList();
        }
      },
      getAccountingRecordsList() {
        this.loading = true;
        let data = {
          userid: Cookies.get("userid-b"),
          roletype: this.roletype,
          parmjsonstr: JSON.stringify(this.listQuery)
        }
        xz.getAccountingRecordsList(data).then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data.data;
            this.totalCount = res.data.totalcount;
            this.loading = false;
          } else {
            this.tableData = [];
            this.totalCount = 0;
            this.loading = false;
          }
        })
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      // 获取部门列表
      getDepartList() {
        xz.getorganstr('', '', {
          strIsDisable: ''
        }).then(res => {
          // console.log('部门', res)
          if (res.status == 'ok') {
            if (res.msg && res.msg.parent) {
              this.departList = res.msg.parent[0].children
            }
          } else {
            this.departList = []
          }
        })
      },
      //选择部门
      handleSectionChange() {
        this.$nextTick(() => {
          let depart = this.$refs.depart.getCheckedNodes()[0];
          console.log(depart)
          // this.query.Strorgancode = depart.value;
          this.formData.department = depart.label;
          this.$refs.depart._data.dropDownVisible = false;
        })
      },
      //选择部门
      handleSectionChange1() {
        this.$nextTick(() => {
          let depart = this.$refs.depart1.getCheckedNodes()[0];
          // this.query.Strorgancode = depart.value;
          this.claimForm.Claim.department = depart.label;
          console.log(depart.label, this.claimForm.Claim.department)
          this.$refs.depart1._data.dropDownVisible = false;
        })
      },
      changeTab() {
        this.tableData = [];
        this.listQuery.ClaimStatus = this.activeName;
        if (this.activeName == '5') {
          this.listQuery.ClaimStatus = '';
          this.listQuery.MatchingType = '';
          this.getAccountingRecordsList();
        } else if (this.activeName == '1') {
          this.listQuery.MatchingType = '1';
          this.getAccountingRecordsList();
        } else if (this.activeName == '0') {
          this.getClaimList();
        } else if (this.activeName == '3') {
          this.listQuery.MatchingType = '1';
          this.listQuery.ClaimStatus = '';
          this.getRefundList();
        } else {
          this.listQuery.MatchingType = '';
          this.getAccountingRecordsList();
        }
      },
      changeTab2() {
        this.getAccountingRecordsList();
      },
      //选择归属
      changeBelong() {
        this.ProjectID = '';
        this.department = '';
        this.claimDepartment = '';
        this.ProjectName = '';
      },
      //选择项目
      changePro(val) {
        this.claimForm.Claim.ProjectID = val.Projectid;
        this.claimForm.Claim.ProjectName = val.StrprojectName;
        this.formData.ProjectID = val.Projectid;
        this.formData.ProjectName = val.StrprojectName;
        this.formData.oppositeName = val.StrCustName;
        let data = {
          userid: Cookies.get("userid-b"),
          ProjectName: val.StrprojectName
        }
        xz.ReportAddApprov(data).then(res => {
          console.log(res)
          if (res.ContractParty != undefined && res.ContractParty) {
            this.ContractParty = res.ContractParty;
          } else {
            this.ContractParty = '';
          }
        })
      },
      //展开表格
      handleExpandChange(row, rows) {
        if (rows.length > 1) {
          this.expands = []
          this.$refs.paymentTable.toggleRowExpansion(rows[0]);
        }
        this.expandQuery = {
          pageNum: 1,
          pageSize: 10,
          IsExport: '0', // 1导出 0 查询
          AccountingRecordId: row.Id
        }
        this.getClaimRecordList();
      },
      currentChangeExpand(val) {
        this.expandQuery.pageNum = Number(val);
        this.getClaimRecordList();
      },
      handleSizeChangeExpand(val) {
        console.log(`每页 ${val} 条`);
        this.expandQuery.pageNum = 1;
        this.expandQuery.pageSize = val;
        this.getClaimRecordList();
      },
      getClaimRecordList() {
        xz.getClaimRecordList(this.expandQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.expands = res.data.data;
            this.expandTotal = res.data.totalcount;
          } else {
            this.expands = [];
            this.expandTotal = 0;
          }
        })
      },
      //导出展开内容
      exportExpand() {
        let data = {
          pageNum: 1,
          pageSize: 100000,
          IsExport: '1', // 1导出 0 查询
          AccountingRecordId: this.expandQuery.AccountingRecordId
        }
        xz.getClaimRecordList(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            let url = res.data;
            let base64 = url.toString()
            let byteCharacters = atob(
              base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            )
            let byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNumbers)
            let blob = new Blob([byteArray], {
              type: `application/excel`
            })
            let aLink = document.createElement("a")
            aLink.download = '到款明细.xls' //这里写保存时的图片名称
            aLink.href = URL.createObjectURL(blob)
            aLink.click()
          } else {

          }
        })
      },
      getClaimList() {
        xz.getClaimRecordList(this.listQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.$nextTick(() => {
              this.loading = false;
              this.tableData2 = res.data.data;
              this.totalCount = res.data.totalcount;
            })
          } else {
            this.loading = false;
            this.tableData = []
            this.totalCount = 0
          }
        })
      },
      claimHandle(row, type) {
        this[type] = true;
        this.claimDepartment = '';
        this.claimBelong = '1';
        this.ProjectName = '';
        this.info = row;
        let now = new Date();
        this.claimForm = {
          Claim: {
            Id: '',
            AccountingRecordId: row.Id, //认领ID
            ProjectID: '', //项目id
            department: '', //部门
            ProjectName: '', //项目名
            PaymentType: '', //到款类型
            ClaimNum: '', //认领编号
            Claimant: '', //认领人
          },
          list: [{
            AmountClaime: row.NotAmountClaimed, //认领金额
            VestingMonth: moment(now).subtract(1, 'months').format('YYYY-MM'), //归属月
            Remark: row.Remark,
          }],
        }
      },
      getRefundList() {
        xz.getRefundList(this.listQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.$nextTick(() => {
              this.tableData2 = res.data.data;
              this.totalCount = res.data.totalcount;
            })
          } else {
            this.tableData = [];
            this.totalCount = 0;
          }
        })
      },
      addLine() {
        let item = {
          AmountClaime: '', //认领金额
          VestingMonth: '', //归属月
          Remark: '',
        }
        this.claimForm.list.push(item)
      },
      delLine(index) {
        this.claimForm.list.splice(index, 1);
      },
      //认领
      confirmClaim() {
        xz.addClaimRecord(this.claimForm, this.roletype, 'addClaimRecord').then(res => {
          if (res.status == 'ok') {
            this.$message.success('认领成功');
            this.showClaim = false;
            this.showClaimFinance = false;
            this.claimHistoryList = res.data.RetList;
            if (this.claimHistoryList.length > 0) {
              this.showClaimHistory = true;
            }
          } else {
            this.$message.error(res.msg);
            this.showClaimFinance = false;
            this.showClaim = false;
          }
        })
      },
      //撤销认领
      revokeClaim(row) {
        this.revokeForm = {
          id: row.Id,
          AmountClaime: '', //撤销认领金额
          remark: '', //备注
        }
        this.info = row;
        this.showRevokeClaim = true;
      },
      confirmRevokeClaim() {
        if (this.revokeForm.AmountClaime) {
          xz.revocationClaimRecord(this.revokeForm, this.roletype).then(res => {
            if (res.status == 'ok') {
              this.$message.success('撤销成功');
              this.showRevokeClaim = false;
            } else {
              this.$message.error(res.msg);
              this.showRevokeClaim = false;
            }
          })
        } else {
          this.$message.warning('请填写撤销认领金额')
        }
      },
      revokePayDuc(row) {
        let d = {
          id: row.Id,
          roletype: this.roletype,
          userid: Cookies.get("userid-b"),
        }
        xz.ArdCurStat(d, 'CancelClaimPayDduc').then(res => {
          if (res.status == 'ok') {
            this.$message.success("撤销抵扣成功！")
          } else {
            this.$message.error(res.msg)
          }
        })
      },
      addPayment() {
        this.paymentPic = [];
        this.PicList = [];
        this.claimBelong = '1';
        this.ProjectName = '';
        let now = new Date();
        this.formData = {
          accountNo: '', //账户号
          accountName: '', //账户名
          bankType: '', //银行类型
          openBank: '', //	开户银行
          incurredAmount: '', //发生金额
          accountBalance: '', //账户余额
          oppositeAccount: '', //对方账户
          oppositeName: '', //对方名称
          oppositeOpeningBank: '', //对方开户银行
          AttachmentUrl: '', //附件url         
          ProjectID: '',
          ProjectName: '',
          department: '',
          AmountClaime: '', //认领金额
          VestingMonth: moment(now).subtract(1, 'months').format('YYYY-MM'), //归属月
          Remark: '',
          PaymentType: '回款', //到款类型
          bankTransactionDate: moment(now).format('YYYY-MM-DD'), //银行交易日期
        }
        this.showAddPayment = true
      },
      //图片预览
      handlePictureCardPreview(file) {
        console.log(file);
        this.dialogImageUrl = file.url;
        this.dialogVisiblePic = true;
      },
      //删除图片
      handleRemovePic(file, fileList) {
        console.log(file, fileList);
        this.paymentPic.forEach((ele, index) => {
          if ((ele) => file.Id === ele.Id) {
            this.paymentPic.splice(index, 1);
          }
        });
        console.log(this.PicList);
      },
      handleExceedPic() {
        this.$message.warning(`最多上传9张图片！`);
      },
      handleChangePic(file) {
        let maxSize = 1024 * 1024 * 5;
        if (file.size <= maxSize) {
          this.uploadImg(file.raw);
        } else {
          xz.imgCompress(file.raw).then((f) => {
            if (f) {
              this.uploadImg(f)
            }
          });
        }
      },
      uploadImg(file) {
        let formData = new FormData();
        formData.append("action", "save");
        formData.append("pagename", "entimg");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("entPicFile", file, file.name);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.paymentPic.push({
              id: "",
              url: res,
            });
            console.log(this.paymentPic)
          } else {
            this.$message("文件上传失败,请稍后再试");
          }
        });
      },
      confirmAddPayment() {
        this.$refs.formData.validate((valid) => {
          if (valid) {
            let url = [];
            if (this.paymentPic.length > 0) {
              this.paymentPic.forEach(item => {
                url.push(item.url)
              })
              this.formData.AttachmentUrl = url.toString()
            }
            xz.addNewMoneyReceived(this.formData, this.roletype).then(res => {
              if (res.status == 'ok') {
                this.$message.success('新增成功');
                this.getAccountingRecordsList();
                this.showAddPayment = false;
                this.claimHistoryList = res.data;
                if (this.claimHistoryList.length > 0) {
                  this.showClaimHistory = true;
                }
              } else {
                this.$message.error(res.msg);
                this.showAddPayment = false;
              }
            })
          }
        })

      },
      importPayment() {
        this.showImportPayment = true;
        this.ExcelSrc = {
          value: "",
          check: false,
          fileName: "",
        }
      },
      downTemp() {
        var path = this.headPath + "excel//E20240119092045969.xlsx";
        const aTag = document.createElement('a')
        aTag.href = path
        aTag.click();
      },
      //文件读取
      async importf() {
        this.isUploadSuccess = false;
        const fileInput = this.$refs.upload;
        FUN.returnExcelSrc(fileInput).then((src) => {
          if (src) {
            this.$set(this.ExcelSrc, "value", src.src);
            this.$set(this.ExcelSrc, "check", false);
            this.$set(this.ExcelSrc, "fileName", fileInput.files[0].name);
            const excelFile = FUN.base64ToFile(
              this.ExcelSrc.value,
              this.ExcelSrc.fileName
            );
            const formData = new FormData();
            formData.append("pagename", "empexcel");
            formData.append("action", "save");
            formData.append("userid", Cookies.get("userid-b"));
            formData.append("entid", this.entid);
            formData.append("excel", excelFile, this.ExcelSrc.fileName);
            console.log("formData", formData);
            xz.uploadCert(formData).then((res) => {
              if (this.isNull(res) || res == false) {
                this.$message("上传Excel失败!");
                this.isUploadSuccess = false;
                this.$refs['upload'].value = null;
              } else {
                this.importForm.url = res;
                this.importForm.View = '1';
                this.$refs['upload'].value = null;
                xz.importToCbsRtnAmt(this.importForm, this.roletype).then(res => {
                  if (res.status == 'ok') {
                    this.importTable = res.data;
                    this.isUploadSuccess = true;
                  } else {
                    this.importTable = [];
                    this.isUploadSuccess = true;
                  }
                })
              }
            });
          } else {
            this.$message("上传Excel失败!");
            this.isUploadSuccess = false;
            this.$refs['upload'].value = null;
          }
        });
      },
      //确认导入excel
      confirmImport() {
        this.importForm.View = '2';
        xz.importToCbsRtnAmt(this.importForm, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.$message.success('导入成功！');
            this.getAccountingRecordsList();
            this.showImportPayment = false;

          } else {
            this.$message.error('导入失败！')
            this.showImportPayment = false;
          }
        })
      },
      confirmImport() {},
      isNull(o) {
        // console.log('isnull',o)
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == "NaN" ||
          o == '[{}]'
        );
      },
      //获取法务主体列表
      getlegalsubjectlist() {
        let d = {
          userid: Cookies.get("userid-b"),
          companyName: '',
          isCanInsure: false,
          pageNum: 1,
          pageSize: 1000
        }
        xz.ArdCurStat(d, 'GetUserLegalList').then(res => {
          if (res.status == 'ok') {
            this.legList = res.data.date;
          } else {
            this.legList = [];
          }
        })
      },
      //认领金额 = 到款金额
      changeAmountClaime() {
        this.formData.incurredAmount = this.formData.AmountClaime;
      },
      expPayment() {
        // let data = {
        //   IncurredAmount: '', //认领金额
        //   AccountName: '', //我方户名
        //   pageNum: 1,
        //   pageSize: 10000,
        //   ProjectIdStr:this.listQuery.ProjectIdStr,
        //   MatchingType: this.listQuery.MatchingType, //有匹配为1,无匹配为2，内部往来为3 
        //   ClaimStatus: this.listQuery.ClaimStatus, //为1未认领，0为已认领完 
        //   IsExport: '1'
        // }
        let d = JSON.parse(JSON.stringify(this.listQuery));
        d.pageSize = 100000;
        d.IsExport = '1'
        let fun = '';
        let Query = {};
        if (this.activeName != '0') {
          Query = {
            userid: Cookies.get("userid-b"),
            roletype: this.roletype,
            parmjsonstr: JSON.stringify(d)
          }
          fun = 'getAccountingRecordsList'
        } else {
          fun = 'getClaimRecordList';
          Query = d
        }
        this.showExportProSum = true;
        xz[fun](Query, this.roletype).then(res => {
          if (res.status == 'ok') {
            let url = res.data;
            let base64 = url.toString()
            let byteCharacters = atob(
              base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            )
            let byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNumbers)
            let blob = new Blob([byteArray], {
              type: `application/pdf`
            })
            let aLink = document.createElement("a");
            aLink.download = '到款导出.xls' //这里写保存时的名称
            aLink.href = URL.createObjectURL(blob)
            aLink.click()
            this.showExportProSum = false;
          } else {
            this.$message.error(res.msg)
            this.showExportProSum = false;
          }
        })
      },
      //下载回单 单个
      downReceiptSingle(row) {
        // let now = new Date();
        // let payDate = moment(row.BankTransactionDate).format('YYYY-MM-DD');
        // let nowDate = moment(now).format('YYYY-MM-DD');
        // let payDate1 = moment(row.BankTransactionDate).add(1, 'days').format('YYYY-MM-DD');
        // let data = {
        //   bdate: payDate,
        //   edate: payDate1,
        //   checkcode: row.CheckCode,
        // }
        // let that = this;
        // xz.getpayaccstr(data).then(res => {
        //   try {
        //     let data = JSON.parse(res.data);
        //     let url = data.list[0].bucketFileUrl;
        //     console.log(url)
        //     const aTag = document.createElement('a')
        //     aTag.href = url
        //     aTag.click();
        //   } catch (e) {
        //     console.log(e)
        //     that.$message.error('下载回单失败！')
        //   }
        // })
        let data = {
          userid: Cookies.get("userid-b"),
          roletype: this.roletype,
          Id: row.Id
        }
        xz.getElectronicReceiptPayment(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            let url = 'https://emp.joball.net/cloudimg/' + res.data;
            const aTag = document.createElement('a')
            aTag.href = url
            aTag.click();
          } else {
            this.$message.error(res.msg)
          }
        })
      },
      refund(row) {
        this.info = row;
        this.showRefund = true;
      },
      confirmRefund(type) {
        this.$refs["refundForm"].validate((valid) => {
          if (valid) {
            if (this.refundForm.RefundAmount > this.info.IncurredAmount) {
              this.$message.warning('退款金额不能大于到款金额！')
            } else {
              this.refundForm.Id = this.info.Id;
              this.refundForm.PaymentTransfer = type;
              this.isBtnLoading = true;
              xz.registerRefund(this.refundForm, this.roletype).then(res => {
                if (res.status == 'ok') {
                  this.$message.success('操作成功');
                  this.getAccountingRecordsList();
                  this.isBtnLoading = false;
                  this.showRefund = false;
                } else {
                  this.$message.error(res.msg);
                  this.getAccountingRecordsList();
                  this.isBtnLoading = false;
                  this.showRefund = false;
                }
              })
            }
          }
        })
      },
      selected(row) {
        console.log(row)
        this.selectedArrData = [row];
      },
      isRed({
        row
      }) {
        const checkIdList = this.selectedArrData.map((item) => item.Id);
        if (checkIdList.includes(row.Id)) {
          return {
            backgroundColor: "oldlace",
          };
        }
      },
      getRowKeys(row) { //行数据的key，用于优化table的渲染
        return row.Id;
      },
      getCurrency(val) {
        if (val) {
          const currencyMap = {
            10: {
              code: 'CNY',
              name: '人民币',
              full: 'RenminbiYuan'
            },
            21: {
              code: 'HKD',
              name: '港币',
              full: 'HongKongDollar'
            },
            32: {
              code: 'USD',
              name: '美元',
              full: 'USDollar'
            },
            43: {
              code: 'GBP',
              name: '英镑',
              full: 'Pound Sterling'
            },
            35: {
              code: 'EUR',
              name: '欧元',
              full: 'Euro'
            },
            65: {
              code: 'JPY',
              name: '日元',
              full: 'JapaneseYen'
            },
            39: {
              code: 'CAD',
              name: '加拿大元',
              full: 'Canadian Dollar'
            },
            29: {
              code: 'AUD',
              name: '澳元',
              full: 'Australian Dollar'
            },
            69: {
              code: 'SGD',
              name: '新加坡元',
              full: 'SingaporeDollar'
            },
            20: {
              code: 'MXN',
              name: '墨西哥比索',
              full: 'mexican peso'
            },
            12: {
              code: 'BRL',
              name: '巴西里亚尔',
              full: 'brazilian real'
            },
            22: {
              code: 'MYR',
              name: '马来西亚林吉特',
              full: 'malaysian ringgit'
            },
            23: {
              code: 'NPR',
              name: '尼泊尔卢比',
              full: 'nepalese rupee'
            },
            24: {
              code: 'NZD',
              name: '新西兰元',
              full: 'newzealand dollar'
            },
            25: {
              code: 'PHP',
              name: '菲律宾比索',
              full: 'philippine peso'
            },
            26: {
              code: 'PKR',
              name: '巴基斯坦卢比',
              full: 'pakistan rupee'
            },
            27: {
              code: 'RUB',
              name: '俄罗斯卢布',
              full: 'U.S.S.R.ruble'
            },
            18: {
              code: 'KWD',
              name: '科威特第纳尔',
              full: 'kuwaiti dinar'
            },
            30: {
              code: 'THB',
              name: '泰国铢',
              full: 'thai baht'
            },
            31: {
              code: 'TWD',
              name: '台湾元',
              full: 'taiwan china dollar'
            },
            13: {
              code: 'IDR',
              name: '印度尼西亚卢比',
              full: 'indonesian rupiah'
            },
            33: {
              code: 'TZS',
              name: '坦桑尼亚先令',
              full: 'tanzania shilling'
            },
            15: {
              code: 'IRR',
              name: '伊朗里亚尔',
              full: 'iranian rial'
            },
            17: {
              code: 'KRW',
              name: '韩国圆',
              full: 'won'
            },
            14: {
              code: 'INR',
              name: '印度卢比',
              full: 'indian rupee'
            },
            16: {
              code: 'JOD',
              name: '约旦第纳尔',
              full: 'jordanian dinar'
            },
            19: {
              code: 'MOP',
              name: '澳门元',
              full: 'macao pataca'
            },
            83: {
              code: 'NOK',
              name: '挪威克朗',
              full: 'norwegian krone'
            },
            85: {
              code: 'DKK',
              name: '丹麦克朗',
              full: 'DanishKrone'
            },
            86: {
              code: 'AED',
              name: '阿联酋迪拉姆',
              full: 'Uae Dirham'
            },
            87: {
              code: 'CHF',
              name: '瑞士法朗',
              full: 'Swiss Franc'
            },
            88: {
              code: 'SEK',
              name: '瑞典克朗',
              full: 'Swedish Krona'
            },
          };
          return currencyMap[val].name || null;
        }
      },
      //导入银行流水信息
      importBankStatement() {
        this.isBtnLoading = false;
        this.bankForm = this.$options.data.call(this).bankForm;
        this.showBankStatement = true;
      },
      handleUpload(file) {
        const formData = new FormData();
        formData.append("pagename", "empexcel");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        console.log("formData", formData);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.bankForm.fileUrl = res;
          } else {
            this.bankForm.fileUrl = ''
          }
        });
      },
      handleRemove() {
        this.batchForm.userListFile = '';
        this.fileList = [];
      },
      handleExceed() {
        this.$message.warning(`最多上传 1 个文件，请先删除再上传`);
      },
      // downBSTemp() {
      //   var path = this.headPath + "excel//E20240119092045969.xlsx";
      //   const aTag = document.createElement('a');
      //   aTag.href = path;
      //   aTag.setAttribute('导入银行流水信息模板.xlsx');
      //   aTag.click();
      // },
      confirmImportBankStatement() {
        this.$refs.bankForm.validate((valid) => {
          if (valid) {
            this.isBtnLoading = true;
            xz.AdvanceFun(this.bankForm, 'ImportmportBankStatement').then(res => {
              if (res.status == 'ok') {
                this.isBtnLoading = false;
                this.$message.success('导入成功');
                this.showBankStatement = false;
                this.getBankStatementList();
              } else {
                this.isBtnLoading = false;
                this.$message.error(res.msg);

              }
            })
          }
        })
      },
      //根据卡号获取银行信息
      getBankInfo(val) {
        if (val) {
          let str = `?AccountNo=${val}`
          xz.ArdCurStatGetFun('GetCardAccountInf', str).then(res => {
            if (res.status == 'ok') {
              this.bankForm.openingBank = res.data.openBank
              this.bankForm.accountName = res.data.accountName
            }
          })
        }
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      batchClaim() {
        if (this.multipleSelection.length > 0) {
          let arr = [];
          let AmountClaime = 0;
          this.multipleSelection.forEach(element => {
            arr.push(element.Id);
            AmountClaime = AmountClaime + element.NotAmountClaimed
          });
          this.showBatchClaim = true;
          this.claimDepartment = '';
          this.claimBelong = '1';
          this.ProjectName = '';
          let now = new Date();
          this.claimForm = {
            Claim: {
              Id: '',
              AccountingRecordId: arr.toString(), //认领ID
              ProjectID: '', //项目id
              department: '', //部门
              ProjectName: '', //项目名
              PaymentType: '', //到款类型
              ClaimNum: '', //认领编号
              Claimant: '', //认领人
            },
            list: [{
              AmountClaime: AmountClaime, //认领金额
              VestingMonth: moment(now).subtract(1, 'months').format('YYYY-MM'), //归属月
            }],
          }
        } else {
          this.$message.warning('请选择要认领的到款')
        }
      },
      confirmBatchClaim() {
        xz.addClaimRecord(this.claimForm, this.roletype, 'addClaimRecordBatch').then(res => {
          if (res.status == 'ok') {
            this.$message.success('认领成功');
            this.showBatchClaim = false;
            this.claimHistoryList = res.data.RetList;
            if (this.claimHistoryList.length > 0) {
              this.showClaimHistory = true;
            }
          } else {
            this.$message.error(res.msg);
            this.showBatchClaim = false;
          }
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .expandTable {
    padding-left: 50px;
  }

  .impDtl {
    font-weight: 600;
    margin-top: 10px;
  }


  .claimTitle {
    font-size: 14px;
    font-weight: 600;
    margin-top: 15px;
  }

  .basicInfo {
    flex-wrap: wrap;
    margin-bottom: 15px;
    padding: 0 30px;
  }

  .infoItem {
    color: #000;
    font-size: 13px;
    min-width: 210px;
    margin-right: 30px;
    line-height: 32px;
  }

  /* 这是原生的input框，给他透明隐藏，然后定位让文件上传的按钮覆盖它 */
  #fileInput {
    width: 120px;
    margin-left: 8px;
    filter: Alpha(opacity=0);
    -moz-opacity: 0;
    opacity: 0;
    position: absolute;
    right: 37px;
    z-index: 2;
  }

  .file-box {
    position: relative;
    display: flex;
    align-items: center;
  }

  .file-box input {
    width: 400px;
    height: 40px;
    line-height: 40px;
    border: 1px solid #cccccc;
    padding-left: 14px;
    box-sizing: border-box;
    border-radius: 4px;
    border: 1px solid #DCDFE6;
  }

  .file-btn {
    display: inline-block;
    width: 54px;
    height: 28px;
    background: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    text-align: center !important;
    line-height: 28px;
    color: #333333;
    margin-left: 8px;
    margin-top: 4px;
  }

  /* 单行文字截断，展示文件名的input框用的 */
  #applyLicense {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
<style>
  .page_salary .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_salary .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_salary .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_salary .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_salary .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_salary .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_salary .el-form-item {
    margin-bottom: 10px;
  }

  .expandTable .el-table__empty-block {
    width: 1095px;
    max-width: 1095px;
    min-width: 1095px;
    padding-right: 0;
  }

  .page_paymentmanage .el-table__expand-icon {
    color: #19bd92;
    font-size: 16px;
    height: 23px;
    line-height: 23px;
    font-weight: 900;
  }

  .page_paymentmanage .el-upload--picture-card {
    width: 120px;
    height: 120px;
    line-height: 128px;
  }

  .page_paymentmanage .el-upload-list--picture-card .el-upload-list__item {
    width: 120px;
    height: 120px;
  }

  .page_paymentmanage .el-form-item__error {
    top: 36px;
  }
</style>